/**
 * Centralized route name constants for all routes in app.routes.tsx.
 * Use these instead of string literals in navigateTo() calls.
 * Values are state names that map to URL paths via STATE_TO_PATH.
 */
export const RouteName = {
    LOGIN: 'login',
    LOGIN_CALLBACK: 'login-callback',
    CHANGE_PASSWORD: 'change-password',
    BROWSER_NOT_SUPPORTED: 'browser-not-supported',
    GUEST: 'guest',
    REACTIVATE_ACCOUNT: 'reactivate-account',
    REVOKE_ACCOUNT: 'revoke-account',
    DASHBOARD: 'dashboard',
    DASHBOARD_ENTRY: 'dashboard.entry',
    DASHBOARD_MAIN: 'dashboard.main',
    DASHBOARD_STORE: 'dashboard.store',
    MULTIPARTY_DASHBOARD: 'multipartyDashboard',
    EMB_DASHBOARD_ERROR: 'emb-dashboard-error',
    NWAY: 'nway',
    INVITE: 'invite',
    JOIN: 'join',
    SESSION_ENDED: 'sessionEnded',
    INVITATION_ENDED: 'invitationEnded',
    HISTORY: 'history',
    VJ_HISTORY: 'vjHistory',
    WIFI_ANALYZER_HISTORY: 'wifiAnalyzerHistory',
    HISTORY_CONSOLE: 'historyConsole',
    CONNECTIVITY_CHECK: 'connectivityCheck',
    CONNECTIVITY_STANDALONE: 'connectivity',
    CONNECTIVITY_GURU_DATA: 'connectivity-guru-data',
    OAUTH_CALLBACK: 'oauth/callback'
} as const;

export type RouteNameType = (typeof RouteName)[keyof typeof RouteName];
